import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { baseColors } from "@Constants/baseStyles"
import React from "react"
import { Platform, PlatformColor, TouchableOpacity, View } from "react-native"
import { Card } from "react-native-paper"
import { RFValue } from "react-native-responsive-fontsize"
import styles from "./styles"

const CustomSimpleCard = (props) => {
    const {
        title,
        paddingHorizontal,
        bgColor,
        onPress,
        marginRight,
        isHomeScreen,
        width,
        fontSize,
        disabled,
        flexSize
    } = props

    if (isHomeScreen) {
        return (
            <TouchableOpacity
                onPress={onPress}
                disabled={disabled}
                style={[
                    styles.cardContainer,
                    { flex: flexSize, backgroundColor: disabled ? baseColors.green.light : baseColors.green.primary }
                ]}
            >
                <BreeSerifText fontSize={RFValue(fontSize ?? 16)} style={styles.title} color={disabled?baseColors.green.pastel:"white"}>
                    {title}
                </BreeSerifText>
            </TouchableOpacity>
        )
    }

    return (
        <TouchableOpacity disabled={disabled} activeOpacity={0.7} onPress={onPress}>
            <Card
                theme={{ roundness: 10 }}
                style={{
                    ...styles.container,
                    marginRight: marginRight ?? 0,
                    width: width ?? undefined,
                    paddingHorizontal: paddingHorizontal ?? Platform.OS === "android" ? 18 : 10,
                    backgroundColor: disabled ? baseColors.green.light : bgColor ?? baseColors.green.dark
                }}
            >
                <BreeSerifText fontSize={RFValue(fontSize ?? 16)} style={styles.title} color={"white"}>
                    {title}
                </BreeSerifText>
            </Card>
        </TouchableOpacity>
    )
}

export default CustomSimpleCard
